import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Services = () => {
    const services = [
        {
            name: "Google Cloud Services",
            image: "../images/gcp.png", // Replace with the correct path to your GCP image
            provider: "GCP",
        },
        {
            name: "Amazon Web Services",
            image: "../images/aws.png", // Replace with the correct path to your AWS image
            provider: "AWS",
        },
        {
            name: "Microsoft Cloud",
            image: "../images/azure.png", // Replace with the correct path to your Azure image
            provider: "Azure",
        },
    ];

    return (
        <section className="services bg-white py-5" id='Services'>
            <Container>
                {/* Heading and Description */}
                <Row className="text-center mb-4">
                    <Col>
                        <h2 className="heading" style={{ fontWeight: "bold", color: "#342ead" }}>
                            Triple Power Cloud Services
                        </h2>
                        <p className="description" style={{ color: "#555" }}>
                            Discover the best-in-class cloud services to power your business with seamless integration and unparalleled efficiency.
                        </p>
                    </Col>
                </Row>
                {/* Services Grid */}
                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card">
                            <img
                                src={service.image}
                                alt={service.provider}
                                style={{
                                    width: "100%",
                                    height: "auto",
                                }}
                            />
                            {/* <h3>{service.provider}</h3>
                            <p style={{ color: "#999" }}>{service.name}</p> */}
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
};

export default Services;
